import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, ChefHat, Zap, Salad, Dumbbell, Leaf, CakeSlice, BadgePercent } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ICONS = { Flame, ChefHat, Zap, Salad, Dumbbell, Leaf, CakeSlice, BadgePercent };

// Generic horizontal chip rail. `items` = [{ id, icon, key, tag }]
export function QuickPicks({ title, items, testId = "quick-picks" }) {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <section data-testid={testId}>
      <h2 className="mb-3 px-4 font-heading text-lg font-extrabold">{title}</h2>
      <div className="no-scrollbar flex gap-2.5 overflow-x-auto px-4 pb-1">
        {items.map((it, i) => {
          const Icon = typeof it.icon === "string" ? ICONS[it.icon] : it.icon;
          return (
            <motion.button
              key={it.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(i * 0.04, 0.3) }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(`/menu?tag=${it.tag || it.id}`)}
              className="flex shrink-0 items-center gap-2 rounded-full border border-border bg-card px-4 py-2.5 text-sm font-semibold shadow-soft transition-colors hover:border-primary/40"
              data-testid={`quick-pick-${it.id}`}
            >
              {Icon && <Icon className="h-4 w-4 text-primary" />}
              {t(it.key)}
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
